import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "experience-section",
  id: "projects"
}
const _hoisted_2 = { class: "experience-container text-in-1" }

import { Experience } from '@/interfaces/experience.interface';
import BaseCard from './BaseCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExperienceSection',
  setup(__props) {

const experienceArray: Experience[] = [
    {
        title: "Desarrollador COBOL, Stefanini México S.A de C.V",
        date: "Noviembre 2022 - Marzo 2026",
        activities: [
            "Redaccion de documentacion tecnica de los requerimientos del usuario.",
            "Analisis, desarrollo e implementacion de requerimeintos funcionales empleando COBOL74 como lenguaje de programacion.",
            "Implementacion de nuevos modulos, mantenimeinto y robostecimiento de modolos existentens en diversos sistemas de Banamex.",
            "Desarrollo de pruebas unitarias e integrales en plataformas de ClearPath MCP (Unisys)",
        ]
    },
    {
        title: "Desarrollador Web",
        date: "Agosto 2021 - Diciembre 2021",
        activities: [
            "Colaboré en el desarrollo de una PWA para la comunidad del ITTG - Instituto Tecnológico de Tuxtla Gutiérrez, con la finalidad de difundir comunicados importantes del Instituto, implementando tecnologías como: HTML, CSS, JavaScript, Laravel y Vue3."
        ]
    },
    {
        title: "Desarrollador Web",
        date: "Enero 2024 - Marzo 2024",
        activities: [
            "Colaboré en el desarrollo de una aplicación web para el control de los animales de un rancho, implementando las siguientes tecnologias: HTML, CSS, JavaScript, Laravel y Vue3."
        ]
    },
    {
        title: "Educación",
        date: "Agosto 2017- Diciembre 2021",
        activities: [
            "Universidad Tecnológico Nacional de México - Campus Tuxtla Gutiérrez, Chiapas.",
            "Licenciatura en Sistemas Computacionales(titulado)",
            "Ingles - Nivel B1 (Harmon Hall)"
        ]
    },
]



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "inter-500" }, "Experiencia", -1)),
      _createVNode(BaseCard, { value: experienceArray })
    ])
  ]))
}
}

})